import React from 'react';
import { useNavigate } from 'react-router-dom';
import UIIconButton from '@/components/shared/UIIconButton';

export interface TenantActionButtonsProps {
  tenantId: string;
  onAction?: (tenantId: string, action: string) => void;
  /**
   * Які кнопки показувати
   */
  actions?: ('view' | 'edit' | 'chat')[];
  /**
   * Додатковий CSS клас
   */
  className?: string;
}

const TenantActionButtons: React.FC<TenantActionButtonsProps> = ({
                                                                   tenantId,
                                                                   onAction,
                                                                   actions = ['view', 'edit', 'chat'],
                                                                   className = ''
                                                                 }) => {
  const navigate = useNavigate();

  const handleViewProfile = () => {
    navigate(`/dashboard/tenants/${tenantId}`);
    onAction?.(tenantId, 'view-profile');
  };

  const handleEditTenant = () => {
    navigate(`/dashboard/tenants/${tenantId}/edit`);
    onAction?.(tenantId, 'edit');
  };

  const handleOpenChat = () => {
    navigate(`/dashboard/chats?chatId=${tenantId}`);
    onAction?.(tenantId, 'chat');
  };

  return (
    <div
      className={`tenant-action-buttons ${className}`}
      style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}
    >
      {actions.includes('view') && (
        <UIIconButton
          variant="info"
          size="medium"
          iconType="userinfo"
          onClick={handleViewProfile}
          title="View tenant profile"
        />
      )}

      {actions.includes('edit') && (
        <UIIconButton
          variant="primary"
          size="medium"
          iconType="edit"
          onClick={handleEditTenant}
          title="Edit tenant"
        />
      )}

      {actions.includes('chat') && (
        <UIIconButton
          variant="success"
          size="medium"
          iconType="contact"
          onClick={handleOpenChat}
          title="Open chat with tenant"
        />
      )}
    </div>
  );
};

export default TenantActionButtons;
